/* NET — data des pages persona (cocon sémantique SEO) */

export const NET_PERSONAS = {
  opticien: {
    slug: "opticien",
    metier: "Opticiens",
    seoTitle: "NET : l'assistant IA souverain des opticiens",
    seoDescription:
      "L'assistant IA souverain pour les opticiens : réponses instantanées, recherche dans vos fiches verriers, préparation de messages MSSanté. Mistral, HDS, RGPD.",
    h1: "L'assistant IA qui fait gagner du temps aux opticiens",
    intro:
      "Entre deux clients, chaque minute compte. NET répond à vos questions métier, retrouve une fiche verrier ou une procédure en quelques secondes et prépare vos messages — vous restez concentré sur le conseil et la vente.",
    missions: [
      "Retrouver une procédure ou une fonctionnalité de votre logiciel",
      "Retrouver une fiche verrier ou une fiche produit en langage naturel",
      "Préparer un message ou une réponse à un client ou un prescripteur",
      "Consulter rapidement les nouveautés fournisseurs et fabricants",
      "Gagner du temps entre deux clients, sans quitter OhMyVue",
    ],
    benefices: [
      { t: "Zéro recherche interminable", d: "Posez votre question en langage naturel, NET fouille la documentation à votre place." },
      { t: "Des réponses homogènes", d: "Toute l'équipe du magasin répond de la même façon, selon vos procédures." },
      { t: "Formation accélérée", d: "Les nouveaux collaborateurs deviennent autonomes en quelques jours." },
    ],
    articles: [
      { slug: "net-assistant-ia-opticien-gagner-temps", title: "NET : l'assistant IA qui fait gagner du temps aux opticiens" },
      { slug: "ia-souveraine-optique-deployer-net-reseau", title: "IA souveraine en optique : déployer NET dans votre réseau" },
      { slug: "centrale-achat-optique-diffuser-offres-net", title: "Centrale d'achat optique : diffuser vos offres via NET" },
    ],
    faq: [
      { q: "NET remplace-t-il mon logiciel opticien ?", a: "Non. NET n'est ni un logiciel métier, ni un dossier patient, ni un agenda. Il vient au-dessus de vos outils existants — notamment OhMyVue — pour les rendre plus simples à utiliser au quotidien." },
      { q: "NET peut-il accéder à mes données clients ?", a: "NET limite les informations selon vos autorisations et respecte les droits utilisateurs. Aucune action sensible n'est exécutée sans votre validation, et il ne contourne jamais les mécanismes de sécurité en place." },
      { q: "Quelle IA se cache derrière NET ?", a: "NET repose sur une approche d'IA souveraine : modèles européens (prioritairement Mistral), hébergement compatible avec les exigences HDS, architecture respectueuse du RGPD et supervision humaine systématique." },
    ],
  },
  audioprothesiste: {
    slug: "audioprothesiste",
    metier: "Audioprothésistes",
    seoTitle: "NET : l'IA des audioprothésistes",
    seoDescription:
      "L'assistant IA souverain pour les audioprothésistes : comptes rendus préparés, documentation fournisseurs interrogeable, réponses métier. Mistral, HDS, RGPD.",
    h1: "L'assistant IA au service des audioprothésistes",
    intro:
      "Comptes rendus, documentations fabricants, procédures de prise en charge : NET retrouve l'information et prépare vos écrits pour que vous consacriez votre temps à l'appareillage et au suivi de vos patients.",
    missions: [
      "Retrouver une documentation fabricant ou une fiche technique",
      "Préparer un compte rendu à faire valider",
      "Retrouver une procédure de prise en charge ou de facturation",
      "Répondre rapidement à une question métier",
      "Consulter les nouveautés fournisseurs sans quitter votre outil",
    ],
    benefices: [
      { t: "Comptes rendus plus rapides", d: "NET prépare une trame claire à partir de vos notes — vous relisez, ajustez, validez." },
      { t: "Documentation unifiée", d: "Toutes vos notices et fiches techniques interrogeables en langage naturel." },
      { t: "Moins d'erreurs", d: "Des réponses construites en priorité sur votre base documentaire maîtrisée." },
    ],
    articles: [
      { slug: "net-assistant-ia-audioprothesiste-souverain", title: "NET : l'IA des audioprothésistes" },
      { slug: "groupement-ia-souveraine-independants-net", title: "Groupements : une IA souveraine pour vos indépendants" },
    ],
    faq: [
      { q: "NET rédige-t-il mes comptes rendus à ma place ?", a: "NET prépare ; le professionnel valide. Il génère une trame de compte rendu à partir de vos éléments, mais la décision et la validation finale restent systématiquement humaines." },
      { q: "Les données de mes patients sont-elles protégées ?", a: "NET fonctionne dans un environnement sécurisé, avec authentification professionnelle, gouvernance des accès et hébergement compatible avec les exigences HDS. Il respecte le RGPD et ne contourne jamais les sécurités." },
      { q: "Comment accéder à NET ?", a: "NET est intégré à l'écosystème MetaConnect et accessible directement depuis OhMyVue, avec une authentification professionnelle." },
    ],
  },
  groupements: {
    slug: "groupements",
    metier: "Groupements & réseaux",
    seoTitle: "NET : l'IA mutualisée des groupements",
    seoDescription:
      "Mutualisez une IA souveraine pour vos adhérents : diffusion de procédures et d'offres, rappels, réponses homogènes. NET par MetaConnect — Mistral, HDS, RGPD.",
    h1: "Une IA souveraine mutualisée pour votre groupement",
    intro:
      "Offrez à tous vos adhérents un collaborateur numérique commun : NET diffuse vos procédures, vos offres et vos rappels, et garantit des réponses homogènes dans tout le réseau — sans multiplier les outils.",
    missions: [
      "Mutualiser l'IA pour l'ensemble de vos adhérents",
      "Diffuser des procédures homogènes dans tout le réseau",
      "Diffuser vos offres et opérations commerciales",
      "Envoyer des rappels et notifications au bon moment",
      "Homogénéiser les réponses apportées aux clients et patients",
    ],
    benefices: [
      { t: "Un réseau aligné", d: "Les mêmes procédures, les mêmes réponses, du premier au dernier point de vente." },
      { t: "Diffusion instantanée", d: "Une nouveauté, une offre, une alerte : toute l'information atteint le terrain immédiatement." },
      { t: "IA mutualisée", d: "Un seul déploiement souverain pour tous vos indépendants, sans complexité technique." },
    ],
    articles: [
      { slug: "groupement-ia-souveraine-independants-net", title: "Groupements : une IA souveraine pour vos indépendants" },
      { slug: "centrale-achat-optique-diffuser-offres-net", title: "Centrale d'achat optique : diffuser vos offres via NET" },
      { slug: "ia-souveraine-optique-deployer-net-reseau", title: "IA souveraine en optique : déployer NET dans votre réseau" },
    ],
    faq: [
      { q: "Comment NET diffuse-t-il nos contenus aux adhérents ?", a: "Vos procédures, offres et guides alimentent le Knowledge Hub, la base documentaire maîtrisée de NET. Les réponses apportées à vos adhérents sont prioritairement construites à partir de cette documentation." },
      { q: "Chaque adhérent doit-il installer quelque chose ?", a: "Non. NET est intégré à l'écosystème MetaConnect et accessible depuis OhMyVue avec une authentification professionnelle — aucun déploiement local n'est nécessaire." },
      { q: "Pouvons-nous contrôler qui accède à quoi ?", a: "Oui. NET s'appuie sur une gouvernance des accès : les informations restituées sont limitées selon les autorisations de chaque utilisateur." },
    ],
  },
  industriels: {
    slug: "industriels",
    metier: "Industriels & fabricants",
    seoTitle: "NET : diffusez vos contenus aux soignants",
    seoDescription:
      "Rendez vos fiches techniques, notices et nouveautés interrogeables en langage naturel par les professionnels, via NET, l'IA souveraine de MetaConnect.",
    h1: "Vos contenus techniques, directement dans le quotidien des professionnels",
    intro:
      "Vos fiches produits, notices et nouveautés méritent mieux qu'un PDF perdu dans une boîte mail. Avec NET, vos contenus deviennent interrogeables en langage naturel par les opticiens et audioprothésistes, au moment exact où ils en ont besoin.",
    missions: [
      "Diffuser vos nouveautés produits auprès des professionnels équipés",
      "Publier vos documentations et notices dans le Knowledge Hub",
      "Mettre à disposition vos fiches techniques, interrogeables en langage naturel",
      "Communiquer directement auprès des professionnels de terrain",
      "Mesurer la portée de vos contenus dans l'écosystème",
    ],
    benefices: [
      { t: "Visibilité au bon moment", d: "Vos produits sont recommandés quand le professionnel pose la question — pas dans une newsletter ignorée." },
      { t: "Contenus toujours à jour", d: "Une seule source documentaire, mise à jour en continu pour tout le réseau." },
      { t: "Canal direct", d: "Un lien sans intermédiaire entre votre marque et les professionnels de santé." },
    ],
    articles: [
      { slug: "industriels-sante-diffuser-infos-pros-net", title: "Industriels : diffuser vos infos aux pros via NET souverain" },
      { slug: "centrale-achat-optique-diffuser-offres-net", title: "Centrale d'achat optique : diffuser vos offres via NET" },
    ],
    faq: [
      { q: "Quels types de contenus pouvons-nous diffuser via NET ?", a: "Fiches produits, notices, documentations techniques, guides, FAQ, contenus de formation et annonces de nouveautés : tout contenu utile aux professionnels peut alimenter le Knowledge Hub." },
      { q: "Comment nos contenus sont-ils restitués ?", a: "Les professionnels interrogent NET en langage naturel. Les réponses sont prioritairement construites à partir de la base documentaire maîtrisée, dont vos contenus font partie." },
      { q: "Est-ce conforme aux exigences du secteur santé ?", a: "Oui. NET repose sur une approche souveraine : modèles européens (prioritairement Mistral), hébergement compatible HDS, RGPD et supervision humaine." },
    ],
  },
  editeurs: {
    slug: "editeurs",
    metier: "Éditeurs de logiciels",
    seoTitle: "NET : l'IA qui documente vos API",
    seoDescription:
      "NET explique vos API, assiste les intégrations, documente vos connecteurs et répond aux questions techniques de vos utilisateurs. IA souveraine MetaConnect.",
    h1: "L'assistant qui accompagne vos utilisateurs et vos intégrations",
    intro:
      "Support de niveau 1 saturé, documentation d'API jamais lue, onboarding interminable : NET répond aux questions techniques et fonctionnelles de vos utilisateurs et guide les développeurs qui intègrent vos connecteurs.",
    missions: [
      "Expliquer vos API et vos connecteurs en langage naturel",
      "Assister les intégrations techniques pas à pas",
      "Documenter vos connecteurs dans une base interrogeable",
      "Guider les développeurs partenaires",
      "Répondre aux questions techniques récurrentes de vos utilisateurs",
    ],
    benefices: [
      { t: "Support déchargé", d: "Les questions récurrentes trouvent leur réponse instantanément, votre équipe se concentre sur les cas complexes." },
      { t: "Intégrations accélérées", d: "Les développeurs partenaires avancent en autonomie, guidés par NET." },
      { t: "Documentation vivante", d: "Vos docs deviennent un assistant interactif, pas un PDF statique." },
    ],
    articles: [
      { slug: "integrer-net-agent-ia-souverain-metaconnect", title: "Intégrer NET : l'agent IA souverain de MetaConnect" },
      { slug: "llm-non-cloisonne-risque-etablissements-sante", title: "LLM non cloisonné : le risque pour les établissements de santé" },
    ],
    faq: [
      { q: "Comment intégrer NET à notre produit ?", a: "NET accompagne les API, les connecteurs et les espaces collaboratifs de l'écosystème MetaConnect. Contactez-nous pour étudier votre cas : l'intégration est guidée de bout en bout." },
      { q: "NET expose-t-il notre savoir-faire technique ?", a: "Non. NET restitue uniquement les contenus que vous choisissez de publier dans le Knowledge Hub, selon la gouvernance des accès que vous définissez." },
      { q: "Pourquoi une IA souveraine plutôt qu'un LLM grand public ?", a: "Un LLM non cloisonné présente des risques réels pour les acteurs de santé : fuite de données, non-conformité RGPD/HDS, réponses non maîtrisées. NET privilégie des modèles européens (Mistral), un hébergement compatible HDS et des réponses construites sur une base documentaire maîtrisée." },
    ],
  },
};

export const NET_PERSONA_LIST = Object.values(NET_PERSONAS);
